import { ApplicationElement, html } from '@effectivastudio/lit-components';
import style from './style.lit.css';

/**
 * Fontawesome icons.
 *
 * This component should not be used on it's own but always through `ef-icon`.
 *
 * ```html
 * <!-- Example -->
 * <ef-icon name='star:solid'></ef-icon>
 * ```
 *
 * Included types:
 *  - Light
 *  - Solid
 *  - Kit (uploaded on fontawesome)
 *
 * Light version is default
 *
 * Usage:
 *
 * ```html
 * <!-- Light -->
 * <fa-icon name="user"></fa-icon>
 * <fa-icon name="user:light"></fa-icon>
 *
 * <!-- Solid -->
 * <fa-icon name="user:solid"></fa-icon>
 *
 * <!-- Brands -->
 * <fa-icon name="user:brands"></fa-icon>
 *
 * <!-- Kit -->
 * <fa-icon name="logo:kit"></fa-icon>*
 *
 * <!-- Fontawesome modifications also works -->
 * <fa-icon name="user fa-beat fa-5x"></fa-icon>*
 *
 * ```
 */

export default class FaIcon extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    name: { type: String },
  };

  render() {
    const [name, ...options] = this.name.split(/\s+/);
    const [icon, type = 'regular'] = name.split(':');
    return html` <i class="fa-${type} fa-${icon} ${options.join(' ')}"></i>`;
  }
}

customElements.get('fa-icon') || customElements.define('fa-icon', FaIcon);
